import * as React from 'react';
import { post } from '../../webapi';
import { Subject, GetSubjectsParams, UpdateRelationParams, TagHolderTypes } from '../../Model/core';

export interface SubjectRelationProps {
    currentPageId: number;
    tagType: TagHolderTypes;
}

export interface SubjectRelationState {
    subjects: Subject[];
}

export class SubjectRelation extends React.Component<SubjectRelationProps, SubjectRelationState> {
    constructor(props: SubjectRelationProps) {
        super(props);

        this.state = { subjects: [] };
    }

    componentDidMount() {
        this.fetchSubjects();
    }

    async fetchSubjects() {
        const { currentPageId, tagType } = this.props;
        const body: GetSubjectsParams = {
            CurrentPageId: currentPageId,
            TagType: tagType
        };

        const subjects = await post<Subject[]>('/blApi/GetSubjects', body);
        this.setState({ subjects });
    }

    async updateSubjectRelation(subjectId: number) {
        const { currentPageId } = this.props;
        type UpdateType = {
            CurrentPageId: number;
            PackageToUpdate: number;
        };
        const body: UpdateType = {
            CurrentPageId: currentPageId,
            PackageToUpdate: subjectId
        };
        const res = await post<boolean>('/blApi/UpdateSubjectRelation', body);
        if (res) {
            this.fetchSubjects();
        }
    }

    render() {
        const { subjects } = this.state;
        return (
            <ul>
                {subjects.map((s) => (
                    <li key={s.PageId}>
                        <input
                            type="checkbox"
                            onChange={(e) => this.updateSubjectRelation(s.PageId)}
                            checked={s.Checked}
                            id={s.PageId.toString()} />
                        <label htmlFor={s.PageId.toString()}>{s.Title}</label>
                    </li>
                ))}
            </ul>
        );
    }
}